import { render, staticRenderFns } from "./marketplan.vue?vue&type=template&id=634757f4&scoped=true&"
import script from "./marketplan.vue?vue&type=script&lang=js&"
export * from "./marketplan.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./marketplan.vue?vue&type=style&index=1&id=634757f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634757f4",
  null
  
)

export default component.exports